import callApi from '../../util/apiCaller';

export const REQUEST_OPPORTUNITY_OWNER_SIGNATURE = 'REQUEST_OPPORTUNITY_OWNER_SIGNATURE';
export const REQUEST_EMAIL_SIGNATURE = 'REQUEST_EMAIL_SIGNATURE';
export const REQUEST_EMAIL_SIGNATURES = 'REQUEST_EMAIL_SIGNATURES';

export function requestOpportunityOwnerSignature(clientId, initiativeId, opportunityId, collectorId = null) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      // over promise
      dispatch({
        type: REQUEST_OPPORTUNITY_OWNER_SIGNATURE, clientId, initiativeId, opportunityId, collectorId, status: 'loading', signature: null, isOwner: null, isMyEmailConfirm: null, owners: [],
      });
      // const uri = `truvoice/clients/${clientId}/initiatives/${initiativeId}/opportunities/${opportunityId}`;
      const uri = `dashboard/win-loss/clients/${clientId}/programs/${initiativeId}/opportunities/${opportunityId}/signatures`;

      callApi(uri, 'GET', { collectorId }).then(
        ({ status, isOwner, isMyEmailConfirm, owners, collectors, dynamicSenders, auth }) => {
          dispatch({
            type: REQUEST_OPPORTUNITY_OWNER_SIGNATURE, clientId, initiativeId, collectorId, id: opportunityId, status: 'loaded', signature: status, isOwner, isMyEmailConfirm, owners, collectors, auth, dynamicSenders,
          });
          resolve(status);
        },
        (errors) => {
          dispatch({
            type: REQUEST_OPPORTUNITY_OWNER_SIGNATURE, clientId, initiativeId, collectorId, id: opportunityId, status: 'error', signature: null, isOwner: null, isMyEmailConfirm: null, owners: [], collectors: [], dynamicSenders: [],
          });
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function requestAccountOwnerSignature(clientId, initiativeId, accountId, collectorId = null) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      // over promise
      dispatch({
        type: REQUEST_OPPORTUNITY_OWNER_SIGNATURE, clientId, initiativeId, accountId, collectorId, status: 'loading', signature: null, isOwner: null, isMyEmailConfirm: null, owners: [],
      });

      // const uri = `truvoice/clients/${clientId}/initiatives/${initiativeId}/accounts/${accountId}`;
      const uri = `dashboard/win-loss/clients/${clientId}/programs/${initiativeId}/accounts/${accountId}/signatures`;
      callApi(uri, 'GET', { collectorId }).then(
        ({ status, isOwner, isMyEmailConfirm, owners, collectors, dynamicSenders, auth }) => {
          dispatch({
            type: REQUEST_OPPORTUNITY_OWNER_SIGNATURE, clientId, initiativeId, id: accountId, collectorId, status: 'loaded', signature: status, isOwner, isMyEmailConfirm, owners, collectors, auth, dynamicSenders,
          });
          resolve(status);
        },
        (errors) => {
          dispatch({
            type: REQUEST_OPPORTUNITY_OWNER_SIGNATURE, clientId, initiativeId, id: accountId, collectorId, status: 'error', signature: null, isOwner: null, isMyEmailConfirm: null, owners: [], collectors: [], dynamicSenders: [],
          });
          reject(errors);
        },
      );
    });
    return p;
  };
}


export function requestEmailSignature(email, silent) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      // over promise
      if (!silent) {
        dispatch({
          type: REQUEST_EMAIL_SIGNATURE, email, status: 'loading', signature: null,
        });
      }
      callApi('me/email-signature', 'GET').then(
        ({ status }) => {
          dispatch({
            type: REQUEST_EMAIL_SIGNATURE, email, status: 'loaded', signature: status,
          });
          resolve(status);
        },
        (errors) => {
          dispatch({
            type: REQUEST_EMAIL_SIGNATURE, email, status: 'error', signature: null,
          });
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function requestEmailSignatureForUser(organization, user) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      // over promise
      const { email } = user;
      dispatch({
        type: REQUEST_EMAIL_SIGNATURE, email, status: 'loading', signature: null,
      });
      callApi(`organizations/${organization._id}/users/${user._id}/email-signature`, 'POST').then(
        ({ status }) => {
          dispatch({
            type: REQUEST_EMAIL_SIGNATURE, email, status: 'loaded', signature: status,
          });
          resolve(status);
        },
        (errors) => {
          dispatch({
            type: REQUEST_EMAIL_SIGNATURE, email, status: 'error', signature: null,
          });
          reject(errors);
        },
      );
    });
    return p;
  };
}


export function createPostmarkSignature(email) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi('me/email-signature', 'POST').then(
        ({ status }) => {
          dispatch({
            type: REQUEST_EMAIL_SIGNATURE, email, status: 'loaded', signature: status,
          });
          resolve(status);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function resendPostmarkConfirmation(email) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi('me/email-signature', 'PUT').then(
        ({ status }) => {
          dispatch({
            type: REQUEST_EMAIL_SIGNATURE, email, status: 'loaded', signature: status,
          });
          resolve({ message: 'Signature email sent!', status });
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}
